import { useNavigate, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { FinanceAnalyseForm } from 'common/forms';

import { QuestionTitle, PageControls } from '../../../../components';
import { useDispatch, useSelector } from 'react-redux';
import {
  selectInvestingAnalyse,
  setInvestingAnalyseValuesAction,
  selectInformationsCustomerInfo1,
} from '../../../../ducks';
import { FinanceAnalyseFormValues } from '../../../../../../common/models/Forms';
import { FormikProps } from 'formik';
import { useFormStepContinueRef } from '../../../../hooks/useFormStepContinueRef';
import { FeatureProps } from '../../../../index';

export default function InvestingAnalyseFeature({ isPrivileged }: FeatureProps) {
  const { t } = useTranslation();
  const { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const initialValues = useSelector(selectInvestingAnalyse);
  const customerValues = useSelector(selectInformationsCustomerInfo1);

  const { bindFormik, continueWithSoftValidation, showSoftContinueHint } =
    useFormStepContinueRef<FinanceAnalyseFormValues>();

  function handleBackClick() {
    navigate(-1);
  }

  async function handleContinueClick() {
    await continueWithSoftValidation((values) => {
      handleSubmit(values);
    });
  }

  function bindSubmit(formik: FormikProps<FinanceAnalyseFormValues>) {
    bindFormik(formik);
  }

  function handleSubmit(values: FinanceAnalyseFormValues) {
    if (!isPrivileged) {
      dispatch(setInvestingAnalyseValuesAction(values));
    }
    navigate(`/form/${id}/investing/agreements`);
  }

  return (
    <>
      <QuestionTitle>{t('investingFeature.analyse')}</QuestionTitle>
      <FinanceAnalyseForm
        initialValues={initialValues || undefined}
        customerValues={customerValues || undefined}
        bindSubmit={bindSubmit}
        onSubmit={handleSubmit}
      />
      <PageControls softContinueHint={showSoftContinueHint} onBack={handleBackClick} onContinue={handleContinueClick} />
    </>
  );
}
